import { GridItem } from '@chakra-ui/react';
import { SelectedProductsWithinOffering } from '@monetize/types/app';
import {
  MBox,
  MCheckbox,
  MText,
  MTooltip,
} from '../../../../../../components/Monetize';
import { PRODUCT_TYPE_DISPLAY } from '../../../../../../constants/products';

const LOCKED_PRODUCT_TOOLTIP =
  'Onetime products cannot be added on an amendment';

interface ManageProductsRowProps {
  row: SelectedProductsWithinOffering;
  index: number;
  value: boolean;
  isDrawer: boolean;
  handleCheckboxChange: (productId: string, value: boolean) => void;
  disabled?: boolean;
  /** Product may not be added or removed on this quote offering */
  isLocked?: boolean;
}

export const ManageProductsRow = ({
  row,
  value,
  isDrawer,
  handleCheckboxChange,
  disabled,
  isLocked,
}: ManageProductsRowProps) => {
  let tooltipLabel: string | null = null;
  if (row.isMandatory) {
    tooltipLabel = 'This product is required';
  } else if (isLocked) {
    tooltipLabel = LOCKED_PRODUCT_TOOLTIP;
  }

  return (
    <GridItem alignSelf="start">
      <MCheckbox
        onChange={(e) => {
          handleCheckboxChange(row.id, e.target.checked);
        }}
        py={2}
        isChecked={value}
        isDisabled={row.isMandatory || disabled || isLocked}
        isReadOnly={row.isMandatory}
      >
        <MTooltip label={tooltipLabel}>
          <MText ml={1}>
            <MBox as="span" fontWeight="bold">
              {row.name}
            </MBox>{' '}
            {`(${PRODUCT_TYPE_DISPLAY[row.productType]})`}
          </MText>
        </MTooltip>
      </MCheckbox>

      <MText pl={7} fontSize="xs">
        {row.name}
      </MText>
    </GridItem>
  );
};
